//replaces change-inverted.html
import classNames from "classnames";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import type { FC } from "react";

interface IChangeInvertedTemplate {
    data: any;
    row: any;
}
export const ChangeInvertedCellTemplateV2: FC<IChangeInvertedTemplate> = (props) => {
    const { data, row } = props;

    return (
        <div
            className={classNames({
                "arrow--negative arrow--negative-inverted": data[row.field] < 0,
                "arrow--positive arrow--positive-inverted": data[row.field] > 0,
            })}
        >
            <span className="singleMetric-cell--value">{dynamicFilterFilter()(data[row.field], row.format)}</span>
        </div>
    );
};
